import styled from 'styled-components'
import { breakpoints } from '../../../../../constants'

export const StyledFields = styled.div`
	display: flex;
	flex-direction: column;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		flex-direction: row;
	}

	& > * {
		margin-bottom: 4rem;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			flex: 1;
		}

		&:not(:last-child) {
			@media screen and (min-width: ${breakpoints.MOBILE}px) {
				margin-right: 15px;
			}
		}
	}
`
